<template>
<!--分学银行-->
  <div class="content">
    <headers></headers>
    <div class="nav">
      <div class="auto">行业证书  >  操作指南  >  证书信息登记   >  个人基本信息 </div>
    </div>
    <div class="auto padding250">
       <p class="title">个人基本信息</p>
      <div class="container ">
        <img src="../../assets/step.png" alt="" style="display: none;">
        <img src="../../assets/step11.png" alt="" style="display: none;">
        <img src="../../assets/step12.png" alt="">
        <div class="formWrapper">
          <Form :label-width="95" label-position="right" class="formMin" >
              <FormItem label="姓名 ">
                <Input  value="" placeholder="请输入姓名" />
              </FormItem>
              <FormItem label="性别" class="txt-left">
                          <Select placeholder="请选择性别">
                              <Option value="">男</Option>
                              <Option value="">女</Option>

                          </Select>
                      </FormItem>
                      <FormItem label="证件类型 " class="txt-left">
                                  <Select placeholder="请选择证件类型">
                                      <Option value="">男</Option>
                                      <Option value="">女</Option>

                                  </Select>
                              </FormItem>
                              <FormItem label="证件号码  ">
                                <Input  value="" placeholder="请输入证件号码 " />
                              </FormItem>
              <FormItem label="出生年月 " >
                <DatePicker class="dateRight" value="2018-09-06"  type="date" placeholder="请选择出生年月" style="width: 233px"></DatePicker>
              </FormItem>
              <FormItem label="民族(字典) " class="txt-left">
                          <Select placeholder="请选择民族">
                              <Option value="">男</Option>
                              <Option value="">女</Option>

                          </Select>
                      </FormItem>
                      <FormItem label="国籍(字典) " class="txt-left">
                                  <Select placeholder="请选择国籍">
                                      <Option value="">男</Option>
                                      <Option value="">女</Option>

                                  </Select>
                              </FormItem>
                              <FormItem label="省份/城市 " class="txt-left">
                                          <Select placeholder="请选择省份/城市">
                                              <Option value="">男</Option>
                                              <Option value="">女</Option>

                                          </Select>
                                      </FormItem>

            <FormItem label="政治面貌(字典) " class="txt-left">
                        <Select placeholder="请选择政治面貌">
                            <Option value="">男</Option>
                            <Option value="">女</Option>

                        </Select>
                    </FormItem>
            <FormItem label="通讯地址  ">
              <Input  value="" placeholder="请输入通讯地址"/>
            </FormItem>
            <FormItem label="联系方式  ">
              <Input  value="" placeholder="请输入联系方式"/>
            </FormItem>
            <FormItem label="电子邮箱 ">
              <Input  value="" placeholder="请输入电子邮箱"/>
            </FormItem>
            <FormItem label=" " class="txt-left">
              <div class="keepThis"><router-link  to="/step1" class="keepBtn">下一步</router-link></div>
            </FormItem>
          </Form>

        </div>
      </div>
    </div>
    <footers></footers>
  </div>
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
  .formWrapper{
    width: 420px;
    padding: 40px 0 0 90px;
  }
  .nav{
    color: #fff;
    background-color: #2F261E;
    height: 60px;
    line-height: 60px;
    font-size: 16px;
  }
  .content{
    background-color: #f5f5f5;
    text-align: left;
    .title{
      font-size: 26px;
      color: #000;
      margin-top: 30px;
    }
    .container{
      background-color: #fff;
      padding: 50px 30px;
      margin-top: 10px;
      text-align: center;

      a{
        color: #fff;
        display: inline-block;
        width: 220px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        border-radius: 5px;
        font-size: 16px;
        background-color: #073C68;
      }
    }
  }
</style>
<script type="text/ecmascript-6">
  import headers from '../template/header'
  import footers from '../template/footer'

    export default {
        name: 'fenxue',
        props: {},
        data() {
            return {};
        },
        methods: {},
        created() {

        },
        components: {
          headers,
          footers

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/changeScore/step.vue